// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackModal-cls1_w5a","cls2":"FeedbackModal-cls2_JOl FeedbackModal-cls1_w5a"};